


































import { Vue, Component } from 'vue-property-decorator'
import { ContentLoader } from 'vue-content-loader'

@Component({
  components: {
    ContentLoader
  }
})
export default class Contentloader extends Vue {
  get size () {
    return (window.innerWidth < 500) ? 200 : 500
  }
}
